 
 
 
 
 
 
define([], function() {
    'use strict';

    return function(data) {
        var coordinates = [];
        if (data.error) {
            throw new Error(data.error);
        }
        if (data.reachableRange &&
            data.reachableRange.boundary &&
            Array.isArray(data.reachableRange.boundary)
        ) {
            coordinates = data.reachableRange.boundary.map(function(coordinates) {
                return [coordinates.longitude, coordinates.latitude];
            });
        }
        return {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [coordinates]
            }
        };
    };
});



// WEBPACK FOOTER //
// ./model/routing/reachableRange.js